module.exports = __webpack_public_path__ + "img/share-w-friend-686x369.cea7a0fb.png";